import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Info } from '../../shared/interface';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrl: './info.component.css',
  encapsulation: ViewEncapsulation.None
})
export class InfoComponent implements OnInit {

  constructor (private apiService: ApiService) {}

  infos: Info[] = [];    

  ngOnInit(): void {
    this.apiService.getInfos().subscribe({
      next: (data) => this.infos = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)
    });
  }
  
}